enum OffersType {
    OFFER_TYPE_FLAT = 1,
    OFFER_TYPE_HOUSE = 2,
    OFFER_TYPE_COMMERCIAL = 3
}

export const defaultOffersTypeOptions = [OffersType.OFFER_TYPE_FLAT, OffersType.OFFER_TYPE_HOUSE];
